export const UPLOADING_LABEL = 'Uploading...';
export const ACCEPT_FORMAT = '.xlsx, .xls';
